import React, { useEffect, useRef } from 'react';
import CustomYouTubePlayer from '../learning/CustomYouTubePlayer';

export default function ResultCard({ resultData, isPlaying, onPlay, onPause }) {
  const {
    name,
    niche,
    startMetric,
    growthMetric,
    rating,
    feedbackText,
    videoThumbnail,
    avatarUrl,
  } = resultData || {};
  const containerRef = useRef(null);

  useEffect(() => {
    const currentContainer = containerRef.current;
    if (!currentContainer) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting && isPlaying) {
          if (onPause) onPause();
        }
      },
      { threshold: 0.15 }
    );

    observer.observe(currentContainer);

    return () => {
      observer.disconnect();
    };
  }, [isPlaying, onPause]);

  const handlePlayToggle = (e) => {
    e.stopPropagation();
    if (!isPlaying && onPlay) {
      onPlay();
    } else if (isPlaying && onPause) {
      onPause();
    }
  };

  return (
    <div ref={containerRef} className={`result-split-card-container ${isPlaying ? 'video-active' : ''}`}>
      
     
      <div
        className="result-media-frame-wrapper"
        onClick={!isPlaying ? handlePlayToggle : undefined}
      >
        {isPlaying ? (
          <CustomYouTubePlayer
            className="result-video-playback-node course-card-player"
            videoUrl="https://www.youtube.com/embed/-h9Vnws9E_4"
            title={`${name || 'Creator'} Success Story Video`}
            autoplay
            mutedAutoplay
            onPlay={onPlay}
            onPause={onPause}
          />
        ) : (
          <>
            <img 
              src={videoThumbnail || "https://images.unsplash.com/photo-1585647347483-22b66260dfff?w=600& digitalq=80"} 
              className="result-video-static-cover" 
              alt={name} 
            />
            <div className="result-video-shadow-curtain" />
          </>
        )}
      </div>

     
      {!isPlaying && (
        <>
          
          {feedbackText ? (
            <div className="result-floating-glass-box feedback-review-box">
              <p className="metric-meta-label">Student Feedback</p>
              <p className="feedback-review-rating">★ {rating || 0}/5</p>
            </div>
          ) : (
            <div className="result-floating-glass-box">
              <p className="metric-meta-label">Started With</p>
              <h4 className="metric-historical-starting-point">{startMetric || "0 Followers"}</h4>
              <div className="metric-trend-arrow-line">
                <span>New</span> <span className="vector-up-arrow">▲</span>
              </div>
              <h2 className="metric-climax-growth-delta">{growthMetric || "100K+"}</h2>
              <p className="metric-meta-sub-label">Subscribers</p>
            </div>
          )}

          
          <button 
            className="result-play-action-trigger-ring"
            onClick={handlePlayToggle}
            aria-label="Play Success Story"
          >
            ▶
          </button>
        </>
      )}

      
      {!isPlaying && (
        <div className="result-persistent-identity-glass-bar">
          <img
            src={avatarUrl || "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&q=80"}
            className="result-identity-avatar-node"
            alt={name}
          />
          <div className="result-identity-meta-text-block">
            <h4 className="result-creator-display-name">{name || "Creator Name"}</h4>
            <p className="result-creator-niche-tag">{niche || "Content Professional"}</p>
          </div>
          <div className="result-identity-star-rating-cluster">
            ★★★★★
          </div>
        </div>
      )}

    </div>
  );
}